export default __webpack_public_path__ + "assets/images/3af69ea1743ab408829f057c343027ce.jpg";